import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";

i18n
  .use(initReactI18next)
  .use(Backend)
  .use(LanguageDetector)
  .init({
    backend: {
      loadPath: "/i18n/{{lng}}/{{ns}}.json", //"/locales/{{lng}}/{{ns}}.json",
    },
    debug: false,
    lng: "es",
    fallbackLng: "en",
    detection: {
      order: ["localStorage", "navigator", "htmlTag"], // Orden de detección
      caches: ["localStorage"], // Almacenar en localStorage
    },
    interpolation: { escapeValue: false },
    // lng: localStorage.getItem('i18nextLng') ? String(localStorage.getItem('i18nextLng')) : 'es',
    // lng: localStorage.getItem('lng') ? localStorage.getItem('lng') : 'es',
  });

export default i18n;
